<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="companyProfileAudits && companyProfileAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="companyProfileAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Company Profile audits </ng-template>
</ng-template>
